import { createFileRoute } from '@tanstack/react-router'
import CareerHomePage from '../components/pages/CareerHomePage'

export const Route = createFileRoute('/')({
  component: IndexRender,
})

function IndexRender() {
  return <CareerHomePage />
}
